import { FC } from "react";
// 方法
import getFormItem from "../hooks/getFormItem";
// 常量
import { EditableCellProps } from "../interface";

const EditableCell: FC<EditableCellProps> = props => {
  const { children, editable, record, tableElement, formItemProps, rowKey, form, rowIndex, ...restProps } = props;
  return (
    <td {...restProps}>
      {
        // @ts-ignore
        editable ? getFormItem(record, rowKey, tableElement, form, { ...formItemProps, rowIndex: rowKey }) : children
      }
      </td>
  );
};

export default EditableCell;